// extracted by mini-css-extract-plugin
export var orderDetails = "_kt-2";
export var orderImage = "_kt-1";
export var orderMeta = "_kt-3";
export var orderSummary = "_kt-0";
export var rightArrow = "_kt-4";